(ns app.front.view.approval.filters
  (:require [app.domain.approval.model :as approval-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.process :as process]
            [app.front.ui :as ui]
            [app.front.ui.select :as ui-select]
            [app.front.util :as futil]
            [app.front.view.approval.form :as approval-form]
            [clojure.string :as str]
            [core.db.entity.util :as eu]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.user.model :as user-model]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))


(rf/reg-sub ::approval-tasks
  (fn [[_ fsm-target] _]
    [(rf/subscribe [::entities/context])
     (rf/subscribe [::approval-form/approvals fsm-target])])
  (fn [[ctx approvals] _]
    (entities/find-entities ctx (filter #(and (eu/is-type? :entity.type/task %)
                                              ((->> approvals (map :db/id) set) (:task/reference %)))))))

(rf/reg-sub ::approval-assignees
  (fn [[_ fsm-target] _]
    [(rf/subscribe [::approval-tasks fsm-target])])
  (fn [[tasks] _]
    (->> tasks
         (map (fn [task]
                (let [group      (:task/user-group task)
                      group-name (:group/long-name group)
                      assignee   (-> task :task/assignees first)
                      is-user?   (eu/is-type? :entity.type/user assignee)]
                  {:id    (:db/id assignee)
                   :title (if is-user?
                            (str (user-model/full-name assignee) " (" group-name ")")
                            group-name)})))
         distinct)))


(rf/reg-event-db
  ::set-approval-filter
  (fn [db [_ key val]]
    (assoc-in db [::approval-filters key] val)))


(rf/reg-sub ::approval-filters
  :-> ::approval-filters)

(rf/reg-sub ::filtered-approvals
  (fn [[_ fsm-target] _]
    [(rf/subscribe [::entities/context])
     (rf/subscribe [::approval-filters])
     (rf/subscribe [::approval-form/approvals fsm-target])])
  (fn [[ctx {:keys [search status delivery-status assigned-to due-date-from due-date-to]} approvals]]
    (let [search-trimmed (some-> search str/lower-case str/trim)]
      (->> approvals
           (filter (fn [a]
                     (let [task       (entities/find-entity ctx {:entity/type    :entity.type/task
                                                                 :task/reference (:db/id a)})
                           assignee   (-> task :task/assignees first)
                           group      (:task/user-group task)
                           group-name (:group/long-name group)
                           is-user?   (eu/is-type? :entity.type/user assignee)]
                       (and (if status (du/in-state? status a) true)
                            (or (not delivery-status)
                                (and (= delivery-status :email-log.delivery-status/unknown)
                                     (-> a approval-model/approval-delivery-status nil?))
                                (-> a approval-model/approval-delivery-status (= delivery-status)))
                            (if assigned-to (= assigned-to (:db/id assignee)) true)
                            (if due-date-from
                              (date-util/on-or-after? (:task/due task)
                                                      (date-util/start-of-day due-date-from))
                              true)
                            (if due-date-to
                              (date-util/on-or-before? (:task/due task)
                                                       (date-util/end-of-day due-date-to))
                              true)
                            (if-not (str/blank? search-trimmed)
                              (or (when is-user?
                                    (str/includes? (-> assignee user-model/full-name str/lower-case) search-trimmed))
                                  (str/includes? (str/lower-case group-name) search-trimmed))
                              true)))))))))


(rf/reg-sub ::sorted-approvals
  (fn [[_ process-target-id _]]
    [(rf/subscribe [::filtered-approvals process-target-id])
     (rf/subscribe [:tr])])
  (fn [[rows tr] [_ _ [attr descending?]]]
    (cond->> rows
      (some? attr)
      (sort-by (fn [row]
                 (let [task     (<sub [::entities/entity {:entity/type    :entity.type/task
                                                          :task/reference (:db/id row)}])
                       assignee (-> task :task/assignees first)]
                   (case attr
                     :approval/status (if (du/in-state? :approval.state/complete row)
                                        (tr [(:approval/result row)])
                                        (tr [(:domain/state row)]))
                     :approval/delivery-status (if-let [status (approval-model/approval-delivery-status row)]
                                                 (tr [status])
                                                 (tr [:email-log.delivery-status/unknown]))
                     :approval/assigned-to (str (-> task :task/user-group :group/long-name)
                                                (when (eu/is-type? :entity.type/user assignee)
                                                  (user-model/full-name assignee)))
                     :approval/request (:entity/created row)
                     :approval/due-date (:task/due task)
                     :approval/completed (:approval/completed row)
                     (get row attr))))
               #(-> (compare %1 %2)
                    (* (if descending? -1 1)))))))


(defn approval-filters [{:keys [process-target tr]}]
  (let [process-target-id      (:db/id process-target)
        approvals              (<sub [::approval-form/approvals process-target-id])
        status-values          (->> approvals
                                    (map :domain/state)
                                    distinct)
        delivery-status-values (->> approvals
                                    (keep approval-model/approval-delivery-status)
                                    (cons :email-log.delivery-status/unknown)
                                    distinct)
        assignee-values        (<sub [::approval-assignees process-target-id])
        filter-values          (<sub [::approval-filters])
        show-delivery-status?  (and (<sub [::ff/enabled? :feature-flag.id/approval-delivery])
                                    (<sub [::process/signal-permitted? process-target [:process.signal/create-approval]]))]
    [:div.flex.flex-auto.flex-col.xxl:flex-row.gap-2
     [:div.flex.flex-auto.flex-row.gap-2
      [ui/search {:id                      "approval-filter-keyword"
                  :container-class         "bx--col px-0 min-w-48 flex-auto"
                  :label-text              (tr [:approval/search])
                  :close-button-label-text (tr [:search/empty])
                  :value                   (:search filter-values)
                  :size                    :medium
                  :on-change               #(rf/dispatch-sync [::set-approval-filter :search (-> % futil/tval str)])
                  :clear-fn                #(>evt [::set-approval-filter :search nil])}]
      [ui-select/select {:id           "approval-filter-status"
                         :label-text   ""
                         :hide-label   true
                         :allow-empty? true
                         :select-text  (tr [:approval/status])
                         :values       status-values
                         :on-change    #(>evt [::set-approval-filter :status %])
                         :value        (:status filter-values)
                         :val->str     #(tr [%])}]
      (when show-delivery-status?
        [ui-select/select {:id           "approval-filter-delivery-status"
                           :label-text   ""
                           :hide-label   true
                           :allow-empty? true
                           :select-text  (tr [:approval/delivery-status])
                           :values       delivery-status-values
                           :on-change    #(>evt [::set-approval-filter :delivery-status %])
                           :value        (:delivery-status filter-values)
                           :val->str     #(tr [%])}])
      [ui-select/select {:id           "approval-filter-assigned-to"
                         :label-text   ""
                         :hide-label   true
                         :allow-empty? true
                         :select-text  (tr [:approval/assigned-to])
                         :values       assignee-values
                         :on-change    #(>evt [::set-approval-filter :assigned-to (:id %)])
                         :value        (p/find-first assignee-values {:id (:assigned-to filter-values)})
                         :val->str     :title}]]
     [:div.flex.flex-1.flex-row.gap-2
      [ui/date-picker {:label-text  ""
                       :placeholder (tr [:approval/due-date-from])
                       :value       (:due-date-from filter-values)
                       :callback    #(>evt [::set-approval-filter :due-date-from %])
                       :hide-label  true}]
      [ui/date-picker {:label-text  ""
                       :placeholder (tr [:approval/due-date-to])
                       :value       (:due-date-to filter-values)
                       :callback    #(>evt [::set-approval-filter :due-date-to %])
                       :hide-label  true}]]]))
